import { render, staticRenderFns } from "./NoSubdomainComponent.vue?vue&type=template&id=538c813d&"
import script from "./NoSubdomainComponent.vue?vue&type=script&lang=js&"
export * from "./NoSubdomainComponent.vue?vue&type=script&lang=js&"
import style0 from "./NoSubdomainComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports